import {
  Divider, List, ListSubheader, useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import SettingsIcon from '@mui/icons-material/Settings';
import CreateIcon from '@mui/icons-material/Create';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import NotificationsIcon from '@mui/icons-material/Notifications';
import FolderIcon from '@mui/icons-material/Folder';
import PersonIcon from '@mui/icons-material/Person';
import StorageIcon from '@mui/icons-material/Storage';
import BuildIcon from '@mui/icons-material/Build';
import PeopleIcon from '@mui/icons-material/People';
import TodayIcon from '@mui/icons-material/Today';
import PublishIcon from '@mui/icons-material/Publish';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import HelpIcon from '@mui/icons-material/Help';
import CampaignIcon from '@mui/icons-material/Campaign';
import GridViewIcon from '@mui/icons-material/GridView';
import RevendasIcon from "@mui/icons-material/EmojiTransportation";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Map from '@mui/icons-material/Map';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from '../../common/components/LocalizationProvider';
import {
  useAdministrator, useManager, useRestriction,
} from '../../common/util/permissions';
import useFeatures from '../../common/util/useFeatures';
import MenuItem from '../../common/components/MenuItem';


const SettingsMenu = () => {
  const t = useTranslation();
  const location = useLocation();

  const readonly = useRestriction('readonly');
  const admin = useAdministrator();
  const manager = useManager();
  const userId = useSelector((state) => state.session.user.id);
  const supportLink = useSelector((state) => state.session.server.attributes.support);

  const features = useFeatures();

  return (
    <>
      <List>
        <MenuItem
          title={t('dashboardMenuText')}
          link="/settings/dashboard"
          icon={<GridViewIcon />}
          selected={location.pathname === '/settings/dashboard'}
        />
         <MenuItem
          title={t('mapTitle')}
          link="/"
          icon={<Map/>}
          // selected={location.pathname === '/settings/preferences'}
        />
        <MenuItem
          title={t('sharedPreferences')}
          link="/settings/preferences"
          icon={<SettingsIcon />}
          selected={location.pathname === '/settings/preferences'}
        />
        {!readonly && (
          <>
            <MenuItem
              title={t('sharedNotifications')}
              link="/settings/notifications"
              icon={<NotificationsIcon />}
              selected={location.pathname.startsWith('/settings/notification')}
            />
            <MenuItem
              title={t('settingsUser')}
              link={`/settings/user/${userId}`}
              icon={<PersonIcon />}
              selected={location.pathname === `/settings/user/${userId}`}
            />
            <MenuItem
              title={t('deviceTitle')}
              link="/settings/devices"
              icon={<SmartphoneIcon />}
              selected={location.pathname.startsWith('/settings/device')}
            />
            <MenuItem
              title={t('sharedGeofences')}
              link="/geofences"
              icon={<CreateIcon />}
              selected={location.pathname.startsWith('/settings/geofence')}
            />
            {!features.disableGroups && (
              <MenuItem
                title={t('settingsGroups')}
                link="/settings/groups"
                icon={<FolderIcon />}
                selected={location.pathname.startsWith('/settings/group')}
              />
            )}
            {!features.disableDrivers && (
              <MenuItem
                title={t('sharedDrivers')}
                link="/settings/drivers"
                icon={<PersonIcon />}
                selected={location.pathname.startsWith('/settings/driver')}
              />
            )}
            {!features.disableCalendars && (
              <MenuItem
                title={t('sharedCalendars')}
                link="/settings/calendars"
                icon={<TodayIcon />}
                selected={location.pathname.startsWith('/settings/calendar')}
              />
            )}
            {!features.disableComputedAttributes && (
              <MenuItem
                title={t('sharedComputedAttributes')}
                link="/settings/attributes"
                icon={<StorageIcon />}
                selected={location.pathname.startsWith('/settings/attribute')}
              />
            )}
            {!features.disableMaintenance && (
              <MenuItem
                title={t('sharedMaintenance')}
                link="/settings/maintenances"
                icon={<BuildIcon />}
                selected={location.pathname.startsWith('/settings/maintenance')}
              />
            )}
            {!features.disableSavedCommands && (
              <>
                <MenuItem
                  title={t('sharedSavedCommands')}
                  link="/settings/commands"
                  icon={<PublishIcon />}
                  selected={location.pathname.startsWith('/settings/command')}
                />
                <MenuItem
                  title={t("sharedCosts")}
                  link="/settings/costs"
                  icon={<AttachMoneyIcon />}
                  selected={location.pathname.startsWith("/settings/cost")}
                />
              </>
            )}
            {supportLink && (
              <MenuItem
                title={t('settingsSupport')}
                link={supportLink}
                icon={<HelpIcon />}
              />
            )}
          </>
        )}
      </List>
      {manager && (
        <>
          <Divider />
          <List>
            <MenuItem
              title={t('serverAnnouncement')}
              link="/settings/announcement"
              icon={<CampaignIcon />}
              selected={location.pathname === '/settings/announcement'}
            />
            {admin && (
            <>
              <MenuItem
                title={t('settingsServer')}
                link="/settings/server"
                icon={<StorageIcon />}
                selected={location.pathname === '/settings/server'}
              />
{/*               <MenuItem */}
{/*                 title={t('sharedRevenda')} */}
{/*                 link="/revendas" */}
{/*                 icon={<RevendasIcon />} */}
{/*                 selected={location.pathname.startsWith('/settings/revendas')} */}
{/*               /> */}
{/*               <MenuItem */}
{/*                 title={t("sharedWhatsapp")} */}
{/*                 link="/settings/whatsapp" */}
{/*                 icon={<WhatsAppIcon />} */}
{/*                 selected={location.pathname === "/settings/whatsapp"} */}
{/*               /> */}
            </>
            )}
            <MenuItem
              title={t('settingsUsers')}
              link="/settings/users"
              icon={<PeopleIcon />}
              selected={location.pathname.startsWith('/settings/user') && location.pathname !== `/settings/user/${userId}`}
            />
          </List>
        </>
      )}
        {/*{admin && (
          <>
            <Divider />
            <List>
              <ListSubheader className={classes.desktopDrawer} component="div" id="nested-list-subheader">
                {t('sharedExtra')}
              </ListSubheader>
              <MenuItem
                title={t('sharedUpdates')}
                link="/settings/updates"
                icon={<NewReleasesIcon />}
                selected={location.pathname === '/settings/updates'}
              />
            </List>
          </>
        )} */}
    </>
  );
};

export default SettingsMenu;
